export class OfferTextModuleModel {
    id: number;  // necessary for right changes comparision functionality
    productType: string; // OfferTextModuleProductTypeEnum;
    textModuleType: string; // OfferTextModuleTypeEnum;
    text: string;
}
